/**
 * YouTube video categories (snippet.categoryId -> human-readable name).
 *
 * Mirror of constants/youtube_publish/upload.py:YOUTUBE_VIDEO_CATEGORIES, which is
 * the canonical source -- keep both in sync. These are the categories assignable
 * to an upload (videoCategories.list assignable=true, US); the `id` string is sent
 * verbatim to the YouTube Data API as snippet.categoryId.
 */

export interface YouTubeCategory {
  id: string;
  name: string;
}

export const YOUTUBE_VIDEO_CATEGORIES: YouTubeCategory[] = [
  { id: '1', name: 'Film & Animation' },
  { id: '2', name: 'Autos & Vehicles' },
  { id: '10', name: 'Music' },
  { id: '15', name: 'Pets & Animals' },
  { id: '17', name: 'Sports' },
  { id: '19', name: 'Travel & Events' },
  { id: '20', name: 'Gaming' },
  { id: '22', name: 'People & Blogs' },
  { id: '23', name: 'Comedy' },
  { id: '24', name: 'Entertainment' },
  { id: '25', name: 'News & Politics' },
  { id: '26', name: 'Howto & Style' },
  { id: '27', name: 'Education' },
  { id: '28', name: 'Science & Technology' },
  { id: '29', name: 'Nonprofits & Activism' },
];

/** Default category when the user has not chosen one (22 = People & Blogs). */
export const DEFAULT_VIDEO_CATEGORY_ID = '22';
